import React, { useState } from 'react';
import {
  ArrowDownIcon,
  FacebookIcon,
  InstagramOriginalIcon,
  LinkedInOriginalIcon,
  TelegramCircleIcon,
  YoutubeIcon
} from 'icons';
import { useTranslations } from 'next-intl';

import { IContacts } from 'modules/courses';
import { isEmptyArr } from 'modules/global';

import BadgeWrapper from './badge-wrapper';
import MobileBadgeWrapper from './mobile-badge-wrapper';

interface IProps {
  contacts?: IContacts[];
  className?: string;
  isTeacherPage?: boolean;
}

const SocialMedia: React.FC<IProps> = ({ contacts, className, isTeacherPage = false }) => {
  const t = useTranslations();
  const [isOpen, setIsOpen] = useState(false);

  if (isEmptyArr(contacts)) return null;

  const iconMap: Record<string, JSX.Element> = {
    telegram: <TelegramCircleIcon className="size-5.5" />,
    instagram: <InstagramOriginalIcon className="size-5.5" />,
    facebook: <FacebookIcon className="size-5.5 text-blue-500" />,
    linkedin: <LinkedInOriginalIcon className="size-5.5" />,
    youtube: <YoutubeIcon className="size-5.5 text-red-500" />
  };

  const toggleAccordion = () => setIsOpen(prev => !prev);

  return (
    <div className={`rounded-xl bg-white ${className}`}>
      {isTeacherPage ? (
        <>
          <div className="flex cursor-pointer items-center gap-2 sm:cursor-default" onClick={toggleAccordion}>
            <span className="text-sm font-medium">{t('ijtimoiy_tarmoqlar')}</span>
            {isTeacherPage && (
              <ArrowDownIcon
                className={`transition-transform duration-300 sm:hidden ${isOpen ? 'rotate-180' : ''} size-4`}
              />
            )}
          </div>

          <BadgeWrapper iconMap={iconMap} contacts={contacts} className="mt-2 hidden grid-cols-2 gap-2 sm:grid" />
          <MobileBadgeWrapper
            iconMap={iconMap}
            contacts={contacts}
            className={`grid grid-cols-2 gap-2 overflow-hidden transition-all duration-300 sm:hidden ${
              isOpen ? 'mt-2 max-h-[999px]' : 'max-h-0'
            }`}
          />
        </>
      ) : (
        <>
          <span className="text-sm font-medium">{t('ijtimoiy_tarmoqlar')}</span>
          <BadgeWrapper iconMap={iconMap} contacts={contacts} className="mt-2 grid grid-cols-2 gap-2" />
        </>
      )}
    </div>
  );
};

export default SocialMedia;
